module.exports = __webpack_public_path__ + "static/media/FrameHistory.cf68f31a.svg";